import { useState } from "react";
import { FiTrash2, FiMail, FiPhone, FiDollarSign, FiClock, FiUser } from "react-icons/fi";
import { FaWhatsapp, FaRobot } from "react-icons/fa";
import { toast } from "react-toastify";
import LeadMessageModal from "./LeadMessageModal";
import useCrmStore from "../../../services/useCrmStore";

const CrmCard = ({
    deal,
    onDragStart,
    onClick,
    onSendMessage,
    isSelected,
    onToggleSelect,
    stages,
    onStageChange,
    members = [],
    onAssigneeChange,
}) => {

    const [isDragging, setIsDragging] = useState(false);
    const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState("WHATSAPP");
    const [isDeleting, setIsDeleting] = useState(false);

    // Usar função deleteLead do store (evita window.location.reload)
    const deleteLeadFromStore = useCrmStore((state) => state.deleteLead);

    const handleDragStart = (e) => {
        setIsDragging(true);
        onDragStart(e, deal.id);
    };

    const handleDragEnd = () => {
        setIsDragging(false);
    };

    const handleClick = () => {
        if (!isDragging) {
            onClick();
        }
    };

    const openMessageModal = (e, channel) => {
        e.stopPropagation();
        setSelectedChannel(channel);
        setIsMessageModalOpen(true);
    };

    const handleDeleteLead = async (e) => {
        e.stopPropagation();
        if (!window.confirm("Tem certeza que deseja excluir este lead?")) return;

        try {
            setIsDeleting(true);
            await deleteLeadFromStore(deal.id);
            toast.success("Lead excluído com sucesso");
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.error || "Erro ao deletar lead");
        } finally {
            setIsDeleting(false);
        }
    };
    const handleSendFromModal = async ({ channel, content, lead, subject, toEmail, integration_id }) => {
        const payload = {
            channel,
            content,
            lead,
            subject,
            toEmail,
            integration_id,
        };

        if (onSendMessage) {
            await onSendMessage(payload);
        }
    };

    

    const handlePhoneCall = (e, rawPhone) => {
        e.stopPropagation();

        if (!rawPhone) {
            alert("Telefone não informado");
            return;
        }

        // 1. Remove tudo que não for número
        let cleaned = rawPhone.replace(/\D/g, "");

        // 2. Remove zeros à esquerda desnecessários
        cleaned = cleaned.replace(/^0+/, "");

        // 3. Garante DDI Brasil (55)
        if (!cleaned.startsWith("55")) {
            cleaned = "55" + cleaned;
        }

        // 4. Validação básica (Brasil: 12 ou 13 dígitos com DDI)
        // if (cleaned.length < 12 || cleaned.length > 13) {
        //     console.warn("Telefone inválido:", cleaned);
        //     return;
        // }

        const formatted = `+${cleaned}`;

        // 5. Dispara ligação
        window.location.href = `tel:${formatted}`;
    };

    const handleWhatsAppClick = (e, rawPhone) => {
        e.stopPropagation();

        if (!rawPhone) {
            alert("Telefone não informado");
            return;
        }

        // 1. Remove tudo que não for número
        let cleaned = rawPhone.replace(/\D/g, "");

        // 2. Remove zeros à esquerda desnecessários
        cleaned = cleaned.replace(/^0+/, "");

        // 3. Garante DDI Brasil (55)
        if (!cleaned.startsWith("55")) {
            cleaned = "55" + cleaned;
        }

        // 4. Abre WhatsApp Web/App com o número
        window.open(`https://wa.me/${cleaned}`, "_blank");
    };


    return (
        <>
            <article
                className={`crm-card ${isDragging ? "crm-card--dragging" : ""}`}
                draggable={true}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
                onClick={handleClick}
                style={{ cursor: isDragging ? "grabbing" : "grab" }}
            >
                <header className="crm-card-header">
                    <div className="crm-card-header-left">
                        <input
                            type="checkbox"
                            className="crm-card-select-checkbox"
                            checked={!!isSelected}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            onChange={(e) => {
                                e.stopPropagation();
                                if (onToggleSelect) {
                                    onToggleSelect(deal.id);
                                }
                            }}
                        />
                    </div>
                    <span className="crm-card-tag">{deal.source || "Lead"}</span>
                    <button
                        className="crm-icon-button"
                        type="button"
                        onClick={handleDeleteLead}
                        disabled={isDeleting}
                        title={isDeleting ? "Excluindo..." : "Excluir lead"}
                    >
                        <FiTrash2 />
                    </button>
                </header>

                <div className="crm-card-title-row">
                    <h4 className="crm-card-title">{deal.name}</h4>

                    <div className="crm-contact-actions">
                        <button
                            type="button"
                            className="crm-contact-btn"
                            onClick={(e) => handleWhatsAppClick(e, deal.phone)}
                            title="Abrir conversa no WhatsApp"
                        >
                            <FaWhatsapp />
                        </button>

                        <button
                            type="button"
                            className="crm-contact-btn"
                            onClick={(e) => openMessageModal(e, "EMAIL")}
                        >
                            <FiMail />
                        </button>

                        <button
                            type="button"
                            className="crm-contact-btn"
                            onClick={(e) => handlePhoneCall(e, deal.phone)}
                        >
                            <FiPhone />
                        </button>
                    </div>
                </div>

                <p className="crm-card-company">{deal.company || deal.email}</p>

                <div className="crm-card-meta">
                    <div className="crm-card-meta-item">
                        <FiDollarSign />
                        <span>Contrato: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(deal.deal_value || 0)}</span>
                    </div>
                    <div className="crm-card-meta-item">
                        <FiClock />
                        <span>{deal.phone || "N/A"}</span>
                    </div>
                </div>

                <footer className="crm-card-footer">
                    <div className="crm-card-assignee">
                        <FiUser className="assignee-icon" />
                        <select
                            value={deal.assigned_to || ""}
                            onChange={(e) => {
                                e.stopPropagation();
                                if (onAssigneeChange) {
                                    onAssigneeChange(deal.id, e.target.value || null);
                                }
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="crm-assignee-select"
                            title="Responsável pelo lead"
                        >
                            <option value="">Sem responsável</option>
                            {members && members.map((member) => (
                                <option key={member.id} value={member.id}>
                                    {member.is_ai_agent ? `${member.name}` : member.name}
                                </option>
                            ))}
                        </select>
                        {members?.find(m => m.id === deal.assigned_to)?.is_ai_agent && (
                            <FaRobot className="ai-badge" title="Atendimento por IA" />
                        )}
                    </div>

                    <div className="crm-stage-selector">
                        <select
                            value={deal.stage_id}
                            onChange={(e) => {
                                e.stopPropagation();
                                if (onStageChange) {
                                    onStageChange(deal.id, e.target.value);
                                }
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="crm-stage-select"
                        >
                            {stages && stages.map((stage) => (
                                <option key={stage.id} value={stage.id}>
                                    {stage.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </footer>
            </article>

            {isMessageModalOpen && (
                <LeadMessageModal
                    channel={selectedChannel}
                    lead={deal}
                    onSend={handleSendFromModal}
                    onClose={() => setIsMessageModalOpen(false)}
                />
            )}
        </>
    );
};

export default CrmCard;
